import Client from './Client';

export default class AgentClient {
  constructor() {
    this.client = Client;
  }

  /**
   *
   * 代理商列表
   */
  async agentPage(data) {
    const res = await this.client.post('/api/agent/page', data);
    return res;
  }

  /**
   * 代理商列表-新增修改
   *
   */

  async agentUpsert(data) {
    const res = await this.client.post('/api/agent/upsert', data);
    return res;
  }

  /**
   * 代理商列表-机构转换代理商
   *
   */

  async insertByAgency(data) {
    const res = await this.client.post('/api/agent/insertByAgency', data);
    return res;
  }

  /**
   * 代理商列表-修改状态
   *
   */

  async agentUpdateValid(data) {
    const res = await this.client.post('/api/agent/updateValid', data);
    return res;
  }

  /**
   * 代理商列表-获取详情
   *
   */

  async agentgetDetail(data) {
    const res = await this.client.post('/api/agent/getDetail', data);
    return res;
  }
  /**
   * 代理商列表-人员列表-新增修改
   *
   */

  async agentUserUpsert(data) {
    const res = await this.client.post('/api/agent/user/upsert', data);
    return res;
  }
  /**
   * 代理商列表-人员列表
   *
   */

  async agentUserPage(data) {
    const res = await this.client.post('/api/agent/user/page', data);
    return res;
  }
  /**
   * 代理商列表-人员列表-修改状态
   *
   */

  async agentUserUpdateValid(data) {
    const res = await this.client.post('/api/agent/user/updateValid', data);
    return res;
  }

  /**
   * 代理商列表-人员列表-权限修改
   *
   */

  async agentUserPermissionUpdate(data) {
    const res = await this.client.post('/api/agent/user/permissionUpdate', data);
    return res;
  }
  /**
   * 代理商列表-课程列表
   *
   */

  async agentCourseList(data) {
    const res = await this.client.post('/api/agent/course/page', data);
    return res;
  }
  /**
   * 代理商列表-课程列表-新增编辑
   *
   */

  async agentCourseUpsert(data) {
    const res = await this.client.post('/api/agent/course/upsert', data);
    return res;
  }
  /**
   * 代理商列表-课程列表-批量新增
   *
   */

  async insertBatch(data) {
    const res = await this.client.post('/api/agent/course/insertBatch', data);
    return res;
  }
  /**
   * 代理商列表-课程列表-批量编辑
   *
   */

  async updateBatch(data) {
    const res = await this.client.post('/api/agent/course/updateBatch', data);
    return res;
  }
  /**
   * 代理商列表-课程列表-状态修改
   *
   */

  async agentCourseUpdateValid(data) {
    const res = await this.client.post('/api/agent/course/updateValid', data);
    return res;
  }

  /**
   * 代理分销配置-列表
   *
   */

  async agentCourseAgencyPage(data) {
    const res = await this.client.post('/api/agent/course/agency/page', data);
    return res;
  }
  /**
   * 代理分销配置-新增修改
   *
   */

  async agentCourseAgencyUpsert(data) {
    const res = await this.client.post('/api/agent/course/agency/upsert', data);
    return res;
  }
  /**
   * 代理分销配置-状态修改
   *
   */

  async agentCourseAgencyUpdateValid(data) {
    const res = await this.client.post('/api/agent/course/agency/updateValid', data);
    return res;
  }
  /**
   * 代理分销配置-已代理课程-下拉
   *
   */

  async agentCourseListAgentCourse(data) {
    const res = await this.client.post('/api/agent/course/listAgentCourse', data);
    return res;
  }
  /**
   * 代理分销配置-已代理课程-下拉
   *
   */

  async agentCourseListAgent(data) {
    const res = await this.client.post('/api/agent/course/agency/listAgency', data);
    return res;
  }
  /**
   * 代理分销配置-已设置机构下拉
   *
   */

  async agentCourseAgencyListAgent(data) {
    const res = await this.client.post('/api/agent/course/agency/listAgency', data);
    return res;
  }

  /**
   * 代理商统计-代理商和人员查询
   *
   */

  async agentListAllName(data) {
    const res = await this.client.post('/api/agent/listAllName', data);
    return res;
  }

  /**
   * 代理商统计-统计
   *
   */

  async agentListStatistics(data) {
    const res = await this.client.post('/api/agent/listStatistics', data);
    return res;
  }
  /**
   * 根据代理商获取有效机构
   *
   */

  async listNameByAgent(data) {
    const res = await this.client.post('/api/agency/listNameByAgent', data);
    return res;
  }
}
